import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { ClassificationSettingsPanel } from '@/components/admin/ClassificationSettingsPanel';
import { CurrencyRatesPanel } from '@/components/admin/CurrencyRatesPanel';
import { MailSettingsPanel } from '@/components/admin/MailSettingsPanel';
import { SendPushPanel } from '@/components/admin/SendPushPanel';
import { Page } from '@/components/layout/Page';

export function AdminSettingsPage() {
  const { user } = useAuth();

  if (!user?.isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <Page className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-foreground">Global Settings</h1>
        <p className="text-sm text-muted-foreground">
          Application-wide configuration (admin only)
        </p>
      </div>

      <MailSettingsPanel />
      <SendPushPanel />
      <CurrencyRatesPanel />
      <ClassificationSettingsPanel />
    </Page>
  );
}
